/**
 * 错误代码处理工具
 * 用于将后端返回的错误代码转换为对应语言的提示信息
 */

import i18n from '@/common/lang';

/**
 * 获取错误提示信息
 * @param {string} errorCode - 错误代码
 * @param {string} defaultMessage - 默认消息（如果没有找到对应翻译）
 * @returns {string} 错误提示信息
 */
export function getErrorMessage(errorCode, defaultMessage = '') {
  if (!errorCode) {
    return defaultMessage || '';
  }

  // 尝试从语言包中获取错误代码对应的翻译
  const translationKey = `errorCodes.${errorCode}`;
  const translatedMessage = i18n.t(translationKey);

  // 如果没有找到翻译（返回的是key本身），则使用默认消息
  if (translatedMessage === translationKey) {
    return defaultMessage || `错误代码: ${errorCode}`;
  }

  return translatedMessage;
}

/**
 * 处理API响应错误
 * 如果响应中包含errorCode，优先使用errorCode对应的翻译
 * @param {object} response - API响应对象
 * @returns {string} 错误提示信息
 */
export function handleApiError(response) {
  if (!response) {
    return '';
  }

  // 优先使用errorCode
  if (response.errorCode) {
    return getErrorMessage(response.errorCode, response.message);
  }

  // 如果没有errorCode，使用message
  if (response.message) {
    return response.message;
  }

  // 都没有的话，返回空字符串（不显示提示）
  return '';
}

export default {
  getErrorMessage,
  handleApiError
};

